import { render, staticRenderFns } from "./aiWatchingVideo.vue?vue&type=template&id=ad8f2902&scoped=true"
import script from "./aiWatchingVideo.vue?vue&type=script&lang=ts"
export * from "./aiWatchingVideo.vue?vue&type=script&lang=ts"
import style0 from "./aiWatchingVideo.vue?vue&type=style&index=0&id=ad8f2902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8f2902",
  null
  
)

export default component.exports